/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import linesBuilder.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./linesBuilder.pure";
import { RegisterLinesBuilder } from "./linesBuilder.pure";
RegisterLinesBuilder();
//# sourceMappingURL=linesBuilder.js.map